import React from "react";
import { Routes, Route } from "react-router";
import SettingsLayout from "./SettingsLayout";
import ZoomApi from "../zoom/pages/ZoomApi";
import MultiStepForm from "../email/components/MultiStepForm";
import EmailSettingStep3 from "../email/pages/EmailSettingStep3";
import RolesAndPrivileges from "../roles-and-priviledges/RolesAndPrivileges";
import AdminManagement from "../admin-management/AdminManagement";
import ProfileAndAccountSetup from "./pages/profile-and-account-setup/ProfileAndAccountSetup";
import Credentials from "../credentials/Credentials";
import PrivilegeGate from "../../../Auth/PrivilegeGate";

const SettingsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SettingsLayout />}>
        <Route
          path="admins"
          element={
            <PrivilegeGate privileges={["viewAdmins"]}>
              <AdminManagement />
            </PrivilegeGate>
          }
        />
        <Route
          path="role-and-privileges"
          element={
            <PrivilegeGate privileges={["viewARole"]}>
              <RolesAndPrivileges />
            </PrivilegeGate>
          }
        />
        <Route
          path="zoom"
          element={
            <PrivilegeGate privileges={["viewMeetings"]}>
              <ZoomApi />
            </PrivilegeGate>
          }
        />
        <Route
          path="email"
          element={
            <PrivilegeGate privileges={["viewEmailTemplates"]}>
              <MultiStepForm />
            </PrivilegeGate>
          }
        />
        <Route
          path="email/test-email"
          element={
            <PrivilegeGate privileges={["viewEmailTemplates"]}>
              <EmailSettingStep3 />
            </PrivilegeGate>
          }
        />
        <Route
          path="profile"
          element={
            <PrivilegeGate privileges={["viewOrganizationProfile"]}>
              <ProfileAndAccountSetup />
            </PrivilegeGate>
          }
        />
        <Route
          path="api-credentials"
          element={
            <PrivilegeGate privileges={["viewApiCredentials"]}>
              <Credentials />
            </PrivilegeGate>
          }
        />
      </Route>
    </Routes>
  );
};

export default SettingsRoutes;
